<script lang="ts">
    import s from './style.module.css';

    export let type: 'submit' | 'button' | 'reset' = 'submit';
    export let onClick = () => {};
    export let disabled = false;
    export let children: any;
    export let side: 'main' | 'subscribed' | 'typ' | 'sms' = 'main';
    export let template = 'circle';
</script>

<div>
    <button
        class="{s.button} {s[template] || ''} {s[side] || ''}"
        {disabled}
        {type}
        on:click={onClick}>{children}</button
    >
</div>
